import { useNotification } from '../../../../hooks'
import { parseServerValidation } from '../../../../utils/validation'
import {
  getProfileContactsWidgetErrorNotificationKey,
  isNoValueContact,
} from '../ProfileContactsWidget.utils'
import {
  PROFILE_CONTACTS_WIDGET_NOTIFICATION_KEY,
  PROFILE_CONTACTS_WIDGET_VALUE_FIELD,
} from '../ProfileContactsWidgetListCell'

export function useProfileContactsWidgetListCellHandlers({
  api,
  contact,
  setIsDeleteValue,
  setModal,
  typeConfig,
  onEdited,
  onEditRequest,
  onSuccess,
}) {
  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  async function handleEditSubmit(values, { setErrors, setSubmitting }) {
    if (!values[PROFILE_CONTACTS_WIDGET_VALUE_FIELD]) {
      setSubmitting(false)
      setIsDeleteValue(true)

      return
    }

    try {
      const value = values[PROFILE_CONTACTS_WIDGET_VALUE_FIELD]

      // A placeholder row has no persisted contact yet — saving it creates one.
      if (isNoValueContact(contact)) {
        await api.create({ typeConfig, value })

        onSuccess()
      } else {
        const updatedValue = await api.edit({
          id: contact.id,
          typeConfig,
          value,
        })

        onEdited(contact.id, updatedValue)
      }

      onEditRequest(null)
      setIsDeleteValue(false)
      handleAddSuccessNotification(
        PROFILE_CONTACTS_WIDGET_NOTIFICATION_KEY.saved
      )
    } catch (error) {
      setSubmitting(false)
      setErrors(parseServerValidation(error))
      handleAddErrorNotification(
        getProfileContactsWidgetErrorNotificationKey(error)
      )
    }
  }

  async function handleConfirmDelete() {
    try {
      await api.remove({ id: contact.id })

      onSuccess()
      onEditRequest(null)
      setModal(null)
      handleAddSuccessNotification(
        PROFILE_CONTACTS_WIDGET_NOTIFICATION_KEY.deleted
      )
    } catch {
      handleAddErrorNotification('Error.CommonApiRequestFailKey')
    }
  }

  return { handleConfirmDelete, handleEditSubmit }
}
